import { CheckSquareOutlined, DownOutlined, EditOutlined, LeftCircleOutlined, MenuOutlined, MenuUnfoldOutlined, RetweetOutlined, RightCircleOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Col, Collapse, Flex, Form, List, message, Modal, Popconfirm, Popover, Row, Space, Table, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormDatePicker, FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import GroupCalculationFormTable from "../components/GroupCalculationFormTable";
import { useDispatch, useSelector } from "react-redux";
import * as service from "../services/paymentApi"
import { setEmployeeGroupCalculation, setEmploymentDeduct, setEmploymentIncome, setIsLoading, updateEmployeeGroupCalculation } from "../slices/PaymentSlices";
import { isDigit } from "utils/validators";
import { current } from "@reduxjs/toolkit";
import { Checkbox, Dropdown } from "antd/lib";
import { P } from "@antv/g2plot";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormItem from "antd/es/form/FormItem";


function useGroupCalculation() {

    const { id } = useParams();
    const { i18n, t } = useTranslation()
    const dispatch = useDispatch()
    const [form] = useForm()
    const [currentRow, setCurrentRow] = useState()
    const [editingKey, setEditingKey] = useState();
    const [calSuccess, setCalSuccess] = useState([]);
    const [calValue, setCalValue] = useState([]);
    const navigate = useNavigate();
    const [newDataStorage, setNewDataStorage] = useState([])
    const [selectedPaginationSize, setSelectedPaginationSize] = useState(100)
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)

    const [incomeFilter, setIncomeFilter] = useState(true)
    const { employeeGroupCalculation = [], isLoading, employmentIncome, employmentDeduct } = useSelector((state) => state.payment)
    console.log("employeeGroupCalculation", employeeGroupCalculation, form.getFieldsValue(true));
    const [pagination, setPagination] = useState({ current: 1, size: 25, pageSize: 25, total: employeeGroupCalculation.length });

    const [openOt, setOpenOt] = useState({
        open: false,
        employeeId: null,
        id: null,
    })

    const isEditingRow = (record) => {
        return true
    }

    const [otState, setOtState] = useState([])

    const onSearchOt = (params) => {
        setOtState(params)
        if (params?.overtimeShiftDetails) {
            params?.overtimeShiftDetails?.forEach?.(o => {
                form.setFieldsValue({
                    [`${o.id}_ot_rate`]: o?.otMultiplyRate,
                    [`${o.id}_totalCal`]: o?.totalCal / 60,
                    [`${o.id}_ot_amount`]: o?.totalPaid,
                    [`${o.id}_ot_overtimeListIds`]: o?.overtimeListIds
                })
            })
        }
    }
    const stpIncomeDeductionByEmploymentType = useMemo(() => {
        // console.log("employmentIncome", employmentIncome, employmentDeduct);

        if (!Array.isArray(employmentIncome) && !Array.isArray(employmentDeduct)) {
            return []
        }
        return [...employmentIncome || [], ...employmentDeduct || []]
    }, [employmentIncome, employmentDeduct])

    console.log("stpIncomeDeductionByEmploymentType", stpIncomeDeductionByEmploymentType);


    const getEmploymentTypeIncomeDeductForSetup = useCallback(async (incomeOrDeduct) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.getEmploymentTypeIncomeDeductionSetupTxn({
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: id,
                // txnPaymentId: currentTxnPayment?.txnPaymentId,
                // type: incomeOrDeduct
            })
            // dispatch(setEmploymentIncomeDeduction(response?.data?.content))
            dispatch(setEmploymentIncome(response?.data?.content?.employeeIncome || []))
            dispatch(setEmploymentDeduct(response?.data?.content?.employeeDeduction || []))
        } catch (error) {
            // Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const getTxnPaymentListByPaginationSize = useCallback(async () => {
        // console.log("selectedPaginationSize", selectedPaginationSize);
        dispatch(setIsLoading(true))
        await service.getEmployeeGroupCalculationPaging({
            companyId: currentCompany,
            employeeId: currentEmployee,
            actionId: currentEmployee,
            txnPayrollPeriodId: id,
            page: 0,
            size: selectedPaginationSize
        }).then((res) => {
            console.log("res?.data?.content", res?.data?.content);
            let ids = []
            res?.data?.content.forEach(o => {
                const { income, deduction } = o
                // console.log("income, deduction", income, deduction);
                // setCalSuccess();
                ids.push(o.id)
                income.forEach(inc => {
                    if (inc?.income?.code == 'I01') {
                        form.setFieldValue(`I01amount_${o.id}`, inc.amount)
                        form.setFieldValue(`I01unit_${o.id}`, inc.unit)
                    } else {

                        console.log("income, deduction", `${inc.id}_amount_${o.id}`, inc.unit);
                        form.setFieldValue(`${inc.id}_amount_${o.id}`, inc.amount)
                        form.setFieldValue(`${inc.id}_unit_${o.id}`, inc.unit)
                    }
                })
                deduction.forEach(inc => {
                    form.setFieldValue(`${inc.id}_amount_${o.id}`, inc.amount)
                })
            })
            setCalSuccess(ids);
            dispatch(setEmployeeGroupCalculation(res?.data?.content))
        })
        dispatch(setIsLoading(false))
    }, [dispatch, form, currentCompany, currentEmployee, id, selectedPaginationSize])

    const onGroupRecalculation = useCallback(async (record) => {
        let calculationData = employeeGroupCalculation?.filter((o) => !o?.editingStatus || (o?.editingStatus && o?.editingStatus == "N"))?.map((o) => {
            return {
                ...o,
                txnPayrollPeriodId: id,
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPaymentId: o?.id,
                incomeListId: o?.income?.map((x) => {
                    return {
                        ...x,
                        incomeDeductionId: x?.income?.id,
                        code: x?.income?.code,
                        statusFlag: "Y"
                    }
                }),
                deductionListId: o?.deduction?.map((x) => {
                    return {
                        ...x,
                        incomeDeductionId: x?.deduction?.id,
                        txnPayrollPeriodId: id,
                        code: x?.deduction?.code,
                        statusFlag: "Y"
                    }
                })

            }
        })
        if (record?.id) {
            calculationData = [...record]
        }
        dispatch(setIsLoading(true))
        await service.previewGroupCalculation({
            companyId: currentCompany,
            employeeId: currentEmployee,
            actionId: currentEmployee,
            employeeIncomeDeduction: calculationData
        }).then((res) => {
            const response = res?.data?.content;
            dispatch(setEmployeeGroupCalculation(employeeGroupCalculation?.map((o) => {
                let recalData = response?.find((xx) => xx?.txnPaymentId === o?.id) || null
                if (recalData) {
                    return {
                        ...o,
                        income: recalData?.incomeListId,
                        deduction: recalData?.deductionListId,
                        editingStatus: "Y"
                    }
                }
                return {
                    ...o
                }
            })))
        })
        dispatch(setIsLoading(false))
    }, [employeeGroupCalculation, dispatch, currentCompany, currentEmployee, id])

    const onSubmitAll = useCallback(async () => {
        console.log("aaaa", form.getFieldsValue(true));
        // console.log("form.getFieldsValue()", form.isFieldsTouched());
        let mod = employeeGroupCalculation?.map((o) => {
            return {
                ...o,
                overtimeRequestId: form.getFieldValue('overtimeListIds_' + o.id),
                txnPayrollPeriodId: id,
                companyId: currentCompany,
                actionId: currentEmployee,
                txnPaymentId: o?.id,
                incomeListId: o?.income?.map((x) => {
                    return {
                        ...x,
                        incomeDeductionId: x?.income?.id,
                        code: x?.income?.code,
                        statusFlag: "Y"
                    }
                }),
                deductionListId: o?.deduction?.map((x) => {
                    return {
                        ...x,
                        incomeDeductionId: x?.deduction?.id,
                        txnPayrollPeriodId: id,
                        code: x?.deduction?.code,
                        statusFlag: "Y"
                    }
                })
            }
        })

        await service.updateEmployeeGroupCalculation({
            companyId: currentCompany,
            employeeId: currentEmployee,
            actionId: currentEmployee,
            employeeIncomeDeduction: mod
        })
        navigate(`/payroll/payment/${id}`);
        // await getTxnPaymentListByPaginationSize();
    }, [form, employeeGroupCalculation, currentCompany, currentEmployee, navigate, id])

    useMemo(() => {
        employeeGroupCalculation?.forEach?.(element => {
            setKeyCal(element.id)
            const { income, deduction } = element
            // console.log("income, deduction", income, deduction);
            // setCalSuccess();
            income.forEach(inc => {
                if (inc?.income?.code == 'I01') {
                    form.setFieldValue(`I01amount_${element.id}`, inc.amount)
                    form.setFieldValue(`I01unit_${element.id}`, inc.unit)
                } else {

                    console.log("income, deduction", `${inc.id}_amount_${element.id}`, inc.unit);
                    form.setFieldValue(`${inc.id}_amount_${element.id}`, inc.amount)
                    form.setFieldValue(`${inc.id}_unit_${element.id}`, inc.unit)
                }
            })
            deduction.forEach(inc => {
                form.setFieldValue(`${inc.id}_amount_${element.id}`, inc.amount)
            })
        });
    }, [employeeGroupCalculation, form])


    const modifiedValueForAddNewIncomeDeduction = useCallback((o, id) => {
        const values = form.getFieldsValue(true);
        let type = o?.income ? "income" : "deduction"
        let amount = values[o?.id + "_amount_" + id] ?? values["I01amount" + id]
        let unit = values[o?.id + "_unit_" + id] ?? values["I01unit" + id]
        console.log("modifiedValueForAddNewIncomeDeduction amount", type, o, values, amount, unit);

        const obj = {
            ...o,
            keyId: id,
            amount: amount,
            unit: unit
        }
        return obj
    }, [form])

    const modifiedSubmitValue = useCallback((data) => {
        const values = form.getFieldsValue(true);
        console.log("stpIncomeDeductionByEmploymentType values", values, stpIncomeDeductionByEmploymentType);
        const seen = new Set();

        const incomeDeductionIdForStp = Object.entries(values)
            .filter(value => {
                return !!value[1]
            })
            .map(([key]) => {
                const parts = key.split("_");
                return {
                    key: parts[0],
                    id: parts[2] ?? parts[1],
                };
            })
            .filter(({ key, id }) => {
                const pair = `${key}|${id}`;

                if (seen.has(pair)) {
                    return false;
                }

                seen.add(pair);
                return true;
            });
        console.log("incomeDeductionIdForStp", incomeDeductionIdForStp);
        const newIncomeDeduction = incomeDeductionIdForStp.flatMap(element => {
            console.log("modifiedValueForAddNewIncomeDeduction element", element, stpIncomeDeductionByEmploymentType)
            return stpIncomeDeductionByEmploymentType
                ?.filter(o => o.id === element.key)
                .map(o => modifiedValueForAddNewIncomeDeduction(o, element.id)) ?? []
        });
        let editingData = null;
        console.log("newIncomeDeduction", newIncomeDeduction);

        return employeeGroupCalculation?.map(o => {
            let deduct = newIncomeDeduction.filter(e => e.keyId == o.id)
            console.log("o?.id", o, deduct);
            console.log("o?.id i01", o?.income.find(o2 => o2.income.code == 'I01'));
            let i01 = o?.income.find(o2 => o2.income.code == 'I01')
            let i01r = {
                ...i01,
                amount: values['I01amount_' + o.id],
                unit: values['I01unit_' + o.id]
            }
            console.log("o?.id i01r", i01r);
            if (deduct?.length > 0) {
                editingData = {
                    ...o,
                    income: [...deduct.filter(o => o.income), i01r],
                    deduction: [...deduct.filter(o => o.deduction)],
                    editingStatus: "Y",
                    txnPaymentId: form?.getFieldValue("txnPaymentId"),
                    overtimeRequestId: values['overtimeListIds_' + o.id]
                }
                return editingData
            }
            return {
                ...o,
                txnPaymentId: form?.getFieldValue("txnPaymentId")
            }
        })

    }, [form, stpIncomeDeductionByEmploymentType, employeeGroupCalculation, modifiedValueForAddNewIncomeDeduction])

    const modifiedValueForRecal = useCallback((data) => {
        let incomeListId = data?.income?.filter((o) => o?.amount != null && (o?.amount != "" || o?.unit != ""))?.map((o) => {
            return {
                ...o,
                code: o?.income?.code,
                type: "income",
                incomeDeductionId: o?.income?.id,
                statusFlag: o?.status || "Y"
            }
        })
        let deductionListId = data?.deduction?.filter((o) => o?.amount != "")?.map((o) => {
            return {
                ...o,
                code: o?.deduction?.code,
                type: "deduction",
                incomeDeductionId: o?.deduction?.id,
                statusFlag: o?.status || "Y"
            }
        })
        return {
            companyId: currentCompany,
            employeeId: data.employeeId,
            actionId: currentEmployee,
            incomeListId: incomeListId,
            deductionListId: deductionListId,
            txnPaymentId: data?.id,
            txnPayrollPeriodId: id
        }
    }, [currentCompany, currentEmployee, id])

    const onRecal = useCallback(async (data, cb = () => { }) => {
        const requestBody = modifiedValueForRecal(data)
        try {
            await service.previewEditEmployeeIncomeDeductInPeriod({
                ...requestBody
            }).then((res) => {
                const values = form.getFieldsValue(true);
                console.log(" v re", values);
                form.resetFields();
                form.setFieldsValue(values);
                const response = res?.data?.content;
                const { incomeListId, deductionListId } = res?.data?.content
                incomeListId.forEach(inc => {
                    if (inc?.income?.code == 'I01') {
                        form.setFieldValue(`I01amount_${data.txnPaymentId}`, inc.amount)
                        form.setFieldValue(`I01unit_${data.txnPaymentId}`, inc.unit)
                    } else {

                        console.log("income, deduction", `${inc.id}_amount_${data.txnPaymentId}`, inc.unit);
                        form.setFieldValue(`${inc.id}_amount_${data.txnPaymentId}`, inc.amount)
                        form.setFieldValue(`${inc.id}_unit_${data.txnPaymentId}`, inc.unit)
                    }
                })
                deductionListId.forEach(inc => {
                    form.setFieldValue(`${inc.id}_amount_${data.txnPaymentId}`, inc.amount)
                })
                dispatch(updateEmployeeGroupCalculation({
                    txnPaymentId: response.txnPaymentId,
                    incomeListId: response.incomeListId.filter(o => o.amount != null),
                    deductionListId: response.deductionListId
                }));
            })
        } catch (error) {
            console.log("error ", error);
        } finally {
            cb?.()
        }
    }, [dispatch, form, modifiedValueForRecal])

    const onSaveEditRow = useCallback(async (record, cb = () => { }) => {
        const modData = modifiedSubmitValue(record)
        const seen = new Set();
        try {
            let diff = Object.entries(record)
                .filter(value => {
                    return !!value[1]
                })
                .map(([key]) => {
                    const parts = key.split("_");
                    return parts[2] ?? parts[1]
                }).filter((id) => {
                    const pair = id;
                    if (seen.has(pair)) {
                        return false;
                    }
                    seen.add(pair);
                    return true;
                });
            let editingData = modData?.filter((o) => diff.includes(o?.id))
            console.log("test ", editingData, modData);
            editingData.forEach(element => {
                onRecal(
                    { ...element, txnPaymentId: element.id },
                    cb
                );
            });
            message.success(t("common.success"))
        } catch (error) {
            console.log("error", error);
            message.error(t("common.error"))
        }

    }, [modifiedSubmitValue, onRecal])
    const onFinish = useCallback(async () => {
        const allValues = form.getFieldsValue(true);
        const changedValues = Object.entries(allValues).filter(([name]) =>
            form.isFieldTouched(name)
        ).map((key => {
            const parts = key[0]?.split("_");
            return parts[2] ?? parts[1]
        }))
        const values = form.getFieldsValue(true);
        console.log("changedValues", changedValues);

        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([key]) =>
                changedValues.some(record => key.endsWith(record))
            )
        );
        console.log("filteredValues", filteredValues);
        function oncall() {
            console.log("oncall");
            changedValues.forEach(element => {
                setKeyCal(element)
            });
            // const values = form.getFieldsValue();
            // form.resetFields();
            // form.setFieldsValue(values);
        }
        onSaveEditRow(filteredValues, oncall)

    }, [form, stpIncomeDeductionByEmploymentType, onSaveEditRow])

    const modifiedInitialValue = useCallback((data) => {
        console.log("dataSource ", data?.income);
        let allIncomeDeduction = [...data?.income || [], ...data?.deduction || []]
        form.setFieldValue("txnPaymentId", data?.id)
        allIncomeDeduction?.forEach((o) => {
            let type = o?.income ? "_income" : "_deduction"
            console.log("type ", `${o?.id}` + "_amount" + type, o?.amount)
            form.setFieldValue(`${o?.id}` + "_amount" + type, o?.amount)
            form.setFieldValue(`${o?.id}` + "_unit" + type, o?.unit)
        })
    }, [form])



    const onEditRow = useCallback((record) => {
        setEditingKey(record?.id)
        modifiedInitialValue(record)
    }, [modifiedInitialValue])
    const onCancelEditRow = useCallback(() => {
        // form.setFieldsValue({ ...record })
        form.resetFields();
        setEditingKey('')
    }, [form])



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const customColumnForIncomeDeduct = ((data, incomeOrDeduct, incomeFilter) => {
        if (data == null || (data != null && data?.lenght == 0)) {
            return
        }
        // console.log("datadata", data);

        return {
            title: i18n.language === 'en' ? data?.nameEn : data?.name,
            dataIndex: data?.incomeDeductionIdNew,
            editable: true,
            type: incomeOrDeduct,
            code: data?.code,
            align: "center",
            width: "250px",
            hidden: !incomeFilter,
            name: data?.incomeDeductionIdNew,
            render: (record, _) => {
                if (incomeOrDeduct === "income") {
                    return _.income?.find?.(o => o.id == data?.incomeDeductionIdNew)?.amount
                }
                return _.deduction?.find?.(o => o.id == data?.incomeDeductionIdNew)?.amount
            },
            onHeaderCell: () => ({
                style: { backgroundColor: incomeOrDeduct === "deduction" ? "#FEE2E2" : '#DCFCE7', color: incomeOrDeduct === "deduction" ? "#991B1B" : '#166534' },
            }),
        };
    })
    const customColumnForDeduct = ((data, incomeOrDeduct, incomeFilter) => {
        if (data == null || (data != null && data?.lenght == 0)) {
            return
        }
        // console.log("datadata", data);
        return {
            title: i18n.language === 'en' ? data?.nameEn : data?.name,
            dataIndex: data?.incomeDeductionIdNew,
            editable: true,
            type: incomeOrDeduct,
            code: data?.code,
            align: "center",
            width: "150px",
            hidden: !incomeFilter,
            name: data?.incomeDeductionIdNew,
            render: (record, _) => {
                if (incomeOrDeduct === "income") {
                    return _.income?.find?.(o => o.id == data?.incomeDeductionIdNew)?.amount
                }
                return _.deduction?.find?.(o => o.id == data?.incomeDeductionIdNew)?.amount
            },
            onHeaderCell: () => ({
                style: { backgroundColor: incomeOrDeduct === "deduction" ? "#FEE2E2" : '#DCFCE7', color: incomeOrDeduct === "deduction" ? "#991B1B" : '#166534' },
            }),
        };
    })
    function setKeyCal(params) {
        setCalSuccess(prev => {
            if (prev.some(item => item === params)) {
                return prev;
            }
            return [...prev, params];
        });
    }
    function resetKeyCal(params) {
        setCalSuccess(prev => [...prev.filter(o => o != params)]);
    }

    const transferStatus = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true))
            await service.transfersToTemp({
                txnPayrollPeriodId: values.id,
            })
            resetKeyCal(values.id)
            dispatch(setEmployeeGroupCalculation(employeeGroupCalculation.filter(o => o.id != values.id)))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [dispatch, employeeGroupCalculation])
    const column = useMemo(() => {
        let baseColumns = [
            {
                title: i18n.language == 'en' ? "employeeNo" : "รหัสพนักงาน",
                dataIndex: 'employeeNo',
                name: 'employeeNo',
                width: "150px",
                editable: false,
                fixed: 'left',
                style: { borderRight: '1px solid #f0f0f0' },
                onHeaderCell: () => ({
                    style: { backgroundColor: '#E7F1FF', color: 'black' },
                }),
                render: (_, record) => {
                    return <Space style={{ justifyContent: "space-between", width: "100%" }}>
                        <span>{_}</span>
                        <Dropdown
                            trigger={["click"]}
                            menu={{
                                items: [
                                    {
                                        key: "ot",
                                        label: "OT",
                                    },
                                    {
                                        key: "return",
                                        label: "ส่งกลับแก้ไข",
                                    },
                                ],
                                onClick: ({ key }) => {
                                    if (key === "ot") {
                                        setOpenOt({
                                            open: true,
                                            employeeId: record.employeeId,
                                            id: record.id,
                                        });
                                    } else if (key === "return") {
                                        console.log("record", record);
                                        Modal.confirm({
                                            title: t("dialog.confirmation.header"),
                                            content:
                                                i18n.language === "en"
                                                    ? "Are you sure you want to cancel the changes?"
                                                    : "คุณต้องการยกเลิกการแก้ไขใช่หรือไม่ ?",
                                            onOk() {
                                                transferStatus(record)
                                            },
                                            okText: t("common.confirm"),
                                            cancelText: t("common.cancel"),
                                        });
                                    }

                                },
                            }}
                        >
                            <Button
                                type="text"
                                icon={<MenuOutlined />}
                            />
                        </Dropdown>
                    </Space>
                }
            },
            {
                title: i18n.language == 'en' ? "employeeName" : "ชื่อพนักงาน",
                dataIndex: 'employeeName',
                name: "employeeName",
                editable: false,
                fixed: 'left',
                width: "150px",
                style: { borderRight: '1px solid #f0f0f0' },
                onHeaderCell: () => ({
                    style: { backgroundColor: '#E7F1FF', color: 'black' },
                }),
                render: (_, record) => {
                    return i18n?.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName
                }
            },
        ]

        const dynamicColumnsForIncome = stpIncomeDeductionByEmploymentType?.filter((o) => o?.income && o?.income.code != "I01").map((o) => {
            const item = o?.income
            return customColumnForIncomeDeduct({ ...item, incomeDeductionIdNew: o?.id }, "income", incomeFilter)
        })

        const dynamicColumnsForDeduction = stpIncomeDeductionByEmploymentType?.filter((o) => o?.deduction).map((o) => {
            const item = o?.deduction
            return customColumnForDeduct({ ...item, incomeDeductionIdNew: o?.id }, "deduction", true)
        })

        let i01 = stpIncomeDeductionByEmploymentType?.filter((o) => o?.income && o?.income.code == "I01")?.[0]?.income;
        if (i01) {
            baseColumns?.push({
                title: <Flex justify="space-between" style={{ paddingRight: "15px", paddingLeft: "15px" }}><span>{i18n.language === 'en' ? i01?.nameEn : i01?.name}</span>
                    {!incomeFilter && <LeftCircleOutlined onClick={() => {
                        setIncomeFilter(true)
                    }} />}
                    {incomeFilter && <RightCircleOutlined onClick={() => {
                        setIncomeFilter(false)
                    }} />}
                </Flex>,
                dataIndex: i01?.incomeDeductionIdNew,
                editable: true,
                type: "income",
                code: i01?.code,
                align: "center",
                width: "250px",
                name: i01?.incomeDeductionIdNew,
                border: !incomeFilter,
                render: (record, _) => {
                    return _.income?.find?.(o => o.id == i01?.incomeDeductionIdNew)?.amount
                },
                onHeaderCell: () => ({
                    style: { backgroundColor: '#DCFCE7', color: '#166534' },
                }),
            })
        }
        const lastColumn = dynamicColumnsForIncome.at(-1);
        if (lastColumn) {
            lastColumn.border = true
            lastColumn.title = (
                <Flex justify="space-between" style={{ paddingRight: "15px", paddingLeft: "15px" }}>
                    <span>{lastColumn.title}</span>
                    {!incomeFilter && (
                        <LeftCircleOutlined onClick={() => setIncomeFilter(true)} />
                    )}
                    {incomeFilter && (
                        <RightCircleOutlined onClick={() => setIncomeFilter(false)} />
                    )}
                </Flex>

            );
            // lastColumn.render = (<div style={style}>{lastColumn.render}</div>)
        }

        baseColumns?.push(...dynamicColumnsForIncome);
        baseColumns?.push(...dynamicColumnsForDeduction)
        const summary = [
            {
                title: 'รายได้สุทธิ',
                dataIndex: 'summary',
                name: 'summary',
                fixed: "right",
                editable: false,
                width: "125px",
                onHeaderCell: () => ({
                    style: { backgroundColor: '#DBEAFE', color: '#1E3A8A' },
                }),
                render: (_, record) => {
                    if (calSuccess?.find(o => o == record.id)) {
                        let income = record?.income?.map(o => o.amount)?.reduce((sum, o) => sum + Number(o), 0);
                        let deduct = record?.deduction?.map(o => o.amount)?.reduce((sum, o) => sum + Number(o), 0);
                        return <div style={{ textAlign: "right" }}>{get2DecimalPointsWithCommas(income - deduct)}</div>
                    }
                    return <>
                        <Flex style={{ justifyContent: "center" }}>
                            <span onClick={() => {
                                const values = form.getFieldsValue(true);
                                const filteredValues = Object.fromEntries(
                                    Object.entries(values).filter(([key]) => key.endsWith(record.id))
                                );
                                console.log("filteredValues", filteredValues);
                                function oncall() {
                                    console.log("oncall");
                                    setKeyCal(record.id)
                                }
                                onSaveEditRow(filteredValues, oncall)

                            }}><RetweetOutlined /></span>
                        </Flex>
                    </>
                },
            },
        ]
        const defaultColumn = [...baseColumns, ...summary];
        return defaultColumn
    }, [i18n.language, stpIncomeDeductionByEmploymentType, t, transferStatus, customColumnForIncomeDeduct, incomeFilter, customColumnForDeduct, calSuccess, form, onSaveEditRow])

    const [checked, setChecked] = useState([]);

    const getFilter = useCallback(() => {
        const incomeOptions = column
            ?.filter(o => o.type === "income")
            .map((o, index) => ({
                label: o.title,
                value: o.dataIndex ?? `income_${index}`,
            })) ?? [];

        const deductionOptions = column
            ?.filter(o => o.type === "deduction")
            .map((o, index) => ({
                label: o.title,
                value: o.dataIndex ?? `deduction_${index}`,
            })) ?? [];

        const dropdownContent = (
            <div
                style={{ width: 500, padding: 12 }}
                onClick={(e) => e.stopPropagation()}
            >
                <Collapse
                    ghost
                    defaultActiveKey={["income", "deduction"]}
                    items={[
                        {
                            key: "income",
                            label: "Income",
                            children: (
                                <Checkbox.Group
                                    options={incomeOptions}
                                    value={checked}
                                    onChange={setChecked}
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, 1fr)",
                                        gap: "8px 16px",
                                    }}
                                />
                            ),
                        },
                        {
                            key: "deduction",
                            label: "Deduction",
                            children: (
                                <Checkbox.Group
                                    options={deductionOptions}
                                    value={checked}
                                    onChange={setChecked}
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, 1fr)",
                                        gap: "8px 16px",
                                    }}
                                />
                            ),
                        },
                    ]}
                />
            </div>
        );
        return (
            <Popover
                trigger="click"
                content={dropdownContent}
            >
                <Button>Filter</Button>
            </Popover>
        );
    }, [column, checked]);

    const paginationSize = [
        {
            key: 0,
            value: 10,
            label: 10
        },
        {
            key: 1,
            value: 20,
            label: 20
        },
        {
            key: 2,
            value: 50,
            label: 50
        },
        {
            key: 3,
            value: 100,
            label: 100
        },
    ]


    const onPaginationSizeChange = useCallback((size) => {
        setSelectedPaginationSize(size)
    }, [])


    const mergedColumns = useMemo(() => {
        return column.map((col, index) => {
            // if (!col.editable) {
            //     return { ...col, style: { borderRight: '1px solid #f0f0f0' } };
            // }
            return {
                ...col,
                onCell: (record, index) => {
                    let dataIndex = col.code == 'I01' ? "I01amount_" + record.id : `${col.dataIndex}_amount_${record.id}`;
                    return {
                        record,
                        dataIndex: dataIndex,
                        title: col.title,
                        editing: col.editable,
                        inputType: col.type,
                        style: { borderRight: '1px solid #f0f0f0' },
                        // or: className: shouldBorder ? 'cell-border-red' : '',
                    };
                },
            };
        });
    }, [column]);
    const oldValue = useRef();

    const EditableCell = useCallback(({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = inputType === 'deduction' ?
            <Flex style={{ padding: 0, margin: 0 }} size={0}>
                <FormInputNumber
                    textAlign="right"
                    // disabled={true}
                    layoutType="horizontal"
                    onFocus={() => {
                        const fieldName = dataIndex
                        oldValue.current = form.getFieldValue(fieldName) || 0;
                    }}
                    onBlur={(value) => {
                        const fieldName = dataIndex
                        const currentValue = form.getFieldValue(fieldName) || 0
                        if (oldValue.current !== currentValue) {
                            resetKeyCal(record.id);
                        }
                    }}
                    controls={false}
                    // variant="filled"
                    name={dataIndex} />
            </Flex> :
            (<Flex style={{ padding: 0, margin: 0, }} size={0}>
                <FormInputNumber
                    width={"75px"}
                    textAlign="right"
                    onFocus={() => {
                        const fieldName = dataIndex?.replace("amount", "unit");
                        oldValue.current = form.getFieldValue(fieldName) || 0;
                    }}
                    onBlur={(value) => {
                        const fieldName = dataIndex?.replace("amount", "unit");
                        const currentValue = form.getFieldValue(fieldName) || 0;
                        if (oldValue.current !== currentValue) {
                            resetKeyCal(record.id);
                        }

                    }}
                    controls={false}
                    layoutType="horizontal"
                    name={dataIndex?.replace("amount", "unit")}
                />
                <FormInputNumber
                    width={"125px"}
                    textAlign="right"
                    // disabled={true}
                    onFocus={() => {
                        const fieldName = dataIndex
                        oldValue.current = form.getFieldValue(fieldName) || 0;
                    }}
                    onBlur={(value) => {
                        const fieldName = dataIndex
                        const currentValue = form.getFieldValue(fieldName) || 0
                        if (oldValue.current !== currentValue) {
                            resetKeyCal(record.id);
                        }

                    }}
                    // variant="filled"
                    controls={false}
                    layoutType="horizontal"
                    name={dataIndex}
                />
            </Flex>);
        return (
            <td {...restProps}>
                {editing ? (
                    inputNode
                ) : (
                    Array.isArray(children) && children?.length > 0 ? children : null
                )}
            </td>
        );
    }, [form])

    useEffect(() => {
        setEmployeeGroupCalculation([])
        setEmploymentDeduct([])
        setEmploymentIncome([])
    }, [])

    const getOvertimeInPeriod = useCallback(async ({ date, fn }) => {
        try {
            dispatch(setIsLoading(true))
            console.log("getOvertimeInPeriod", date);
            let startPeriod = date?.[0]?.format?.("YYYY-MM-DD")
            let endPeriod = date?.[1]?.format?.("YYYY-MM-DD")
            const response = await service.getOvertimeInPeriod({
                companyId: currentCompany,
                employeeId: openOt?.employeeId,
                actionId: currentEmployee,
                txnPayrollPeriodId: id,
                startPeriod,
                endPeriod
                // txnPaymentId: currentTxnPayment?.txnPaymentId,
                // type: incomeOrDeduct
            })
            fn?.(response?.data?.content)
            // dispatch(setEmploymentIncomeDeduction(response?.data?.content))
            // dispatch(setEmploymentIncome(sponsresponse?.data?.content?.employeeIncome || []))
            // dispatch(setEmploymentDeduct(ree?.data?.content?.employeeDeduction || []))
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, dispatch, id, openOt?.employeeId])

    const modelOt = useCallback(
        () => {
            // openOt
            return <Modal open={openOt.open} onCancel={() => {
                setOpenOt({
                    open: false,
                    employeeId: null,
                    id: null
                })
                setOtState([])
            }} onOk={() => {
                console.log("ok", form.getFieldsValue(true));
                const values = form.getFieldsValue(true);
                let overtimeListIdsTemp = []
                const result = Object.keys(values)
                    .filter(key => key.endsWith("_ot"))
                    .reduce((acc, key) => {
                        const prefix = key.slice(0, -3); // remove "_ot"
                        const otId = values[`${prefix}_ot`];
                        const amount = Number(values[`${prefix}_ot_amount`] || 0);
                        const totalCal = Number(values[`${prefix}_totalCal`] || 0);
                        const overtimeListIds = (values[`${prefix}_ot_overtimeListIds`] || []);
                        // console.log("overtimeListIds", `${prefix}_ot_overtimeListIds`, values, overtimeListIds);

                        if (!acc[otId]) {
                            acc[otId] = {
                                otId,
                                amount: 0,
                                totalCal: 0,
                                overtimeListIds: []
                            };
                        }
                        acc[otId].amount += amount;
                        acc[otId].totalCal += totalCal;
                        overtimeListIds.forEach(element => {
                            overtimeListIdsTemp.push(element)
                        });
                        return acc;
                    }, {});

                console.log("result", Object.values(result), overtimeListIdsTemp);
                Object.values(result).forEach(o => {
                    form.setFieldValue(o.otId + "_amount_" + openOt.id, o.amount)
                    form.setFieldValue(o.otId + "_unit_" + openOt.id, o.totalCal)

                })
                form.setFieldValue("overtimeListIds_" + openOt.id, overtimeListIdsTemp)
                console.log("form.getFieldValue()", form.getFieldValue("overtimeListIds_" + openOt.id), overtimeListIdsTemp);

                const suffixes = [
                    "_ot",
                    "_ot_amount",
                    "_ot_rate",
                    "_ot_overtimeListIds",
                    "_totalCal",
                ];

                const fieldsToReset = Object.keys(form.getFieldsValue(true)).filter(key => {
                    return suffixes.some(suffix => key.endsWith(suffix))
                }
                );
                console.log("fieldsToReset", fieldsToReset);

                form.resetFields(fieldsToReset);

                let allValues = form.getFieldsValue(true)
                const changedValues = Object.entries(allValues).filter(([name]) =>
                    name.endsWith(openOt.id)
                ).map((key => {
                    const parts = key[0]?.split("_");
                    return parts[2] ?? parts[1]
                }))
                const suffixes2 = employmentIncome?.filter?.(o => o?.income?.overTime == 'Y').map(o => o.id).filter(o => !Object.values(result).map(o => o.otId).includes(o))

                const fieldsToReset2 = Object.keys(form.getFieldsValue(true)).filter(key =>
                    suffixes2.some(suffix => key.startsWith(suffix) && key.endsWith(openOt.id))
                );
                console.log("fieldsToReset2", fieldsToReset2);
                form.resetFields(fieldsToReset2);

                console.log("changedValues", changedValues);

                const filteredValues = Object.fromEntries(
                    Object.entries(values).filter(([key]) =>
                        changedValues.some(record => key.endsWith(record))
                    )
                );



                console.log("filteredValues", filteredValues);
                function oncall() {
                    console.log("oncall");
                    changedValues.forEach(element => {
                        setKeyCal(element)
                    });
                    // const values = form.getFieldsValue();
                    // form.resetFields();
                    // form.setFieldsValue(values);
                }
                onSaveEditRow(filteredValues, oncall)

                setOpenOt({
                    open: false,
                    employeeId: null
                })
                setOtState([])
            }}>
                <FormAntd form={form}>
                    <FormItem shouldUpdate={(prev, curv) => {
                        return true
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields, getFieldsValue }) => {
                            return (
                                <Row style={{ width: "100%" }}>
                                    <Col span={24}  >
                                        <Space direction="vertical">
                                            <Card title={
                                                <Flex justify="space-between" align="center">
                                                    <label>ค่าทำงานล่วงเวลา</label>
                                                    <Button type="primary" style={{ height: "40px", borderRadius: "8px", backgroundColor: "#FFA500", fontWeight: "bold", boxShadow: "none" }}
                                                        onClick={() => {
                                                            otState?.overtimeShiftDetails?.forEach?.(o => {
                                                                console.log("ot ", o, (o?.totalCal / 60) * (otState?.basePerHour * o?.otMultiplyRate))
                                                                form.setFieldsValue({
                                                                    [`${o.id}_ot_rate`]: o?.otMultiplyRate,
                                                                    [`${o.id}_totalCal`]: o?.totalCal / 60,
                                                                    [`${o.id}_ot_amount`]: o?.totalPaid,
                                                                    [`${o.id}_ot_overtimeListIds`]: o?.overtimeListIds
                                                                })
                                                            })
                                                        }} >
                                                        {t("appearance.label.reset")}
                                                    </Button>
                                                </Flex>} style={{ width: "40vw" }}>
                                                <div style={{ overflowY: 'scroll' }}>
                                                    <span style={{ color: "#42526D" }}>{t("start-date-to-end-date")}</span>
                                                    <Flex gap={5}>
                                                        <FormDatePicker name="dateRangeOt" type="range"></FormDatePicker>
                                                        <Button onClick={() => {
                                                            getOvertimeInPeriod({ date: getFieldValue('dateRangeOt'), fn: onSearchOt })
                                                        }}
                                                            type="primary"
                                                            style={{ backgroundColor: "#2CADE7", fontWeight: "bold" }}
                                                        >
                                                            {t("common.search")}
                                                        </Button>
                                                    </Flex>
                                                    <Flex vertical style={{ marginTop: "16px" }}>
                                                        <Row gutter={12}>
                                                            <Col span={9}>
                                                            </Col>
                                                            <Col span={5} style={{ textAlign: "center" }}>
                                                                <span style={{ color: "#667085" }}>{t("employmentType.label.times")}</span>
                                                            </Col>
                                                            <Col span={5} style={{ textAlign: "center" }}>
                                                                <span style={{ color: "#667085" }}>{t("leave_type.label.leave-hour")}</span>
                                                            </Col>
                                                            <Col span={5} style={{ textAlign: "center" }}>
                                                                <span style={{ color: "#667085" }}>{t("dashboard.label.amount")}</span>
                                                            </Col>
                                                        </Row>
                                                        <List
                                                            dataSource={otState?.overtimeShiftDetails}
                                                            renderItem={(item) => (
                                                                <List.Item style={{ display: "block" }}>
                                                                    {/* <Flex gap={5} justify="space-between" style={{ textAlign: "center" }}> */}
                                                                    <Row gutter={12}>
                                                                        <Col span={9}>
                                                                            <FormSelect
                                                                                allowClear
                                                                                placeholder={"กรุณาเลือก"} name={`${item?.id}_ot`} options={employmentIncome?.filter?.(o => o?.income?.overTime == 'Y').map(o =>
                                                                                ({
                                                                                    label: i18n.language === "en" ? o?.income?.nameEn : o?.income?.name,
                                                                                    value: o?.id
                                                                                })
                                                                                )}>
                                                                            </FormSelect>
                                                                        </Col>
                                                                        <Col span={5}>
                                                                            <FormInputNumber
                                                                                textAlign={'right'}
                                                                                name={`${item?.id}_ot_rate`}
                                                                                controls={false}
                                                                                disabled
                                                                                required
                                                                                min={0.00} />
                                                                        </Col>
                                                                        <Col span={5}>
                                                                            <FormInputNumber
                                                                                textAlign={'right'}
                                                                                controls={false}
                                                                                name={`${item?.id}_totalCal`}
                                                                                onChange={(e) => {
                                                                                    console.log("e", e);
                                                                                    setFieldValue(`${item?.id}_ot_amount`, e * getFieldValue(`${item?.id}_ot_rate`) * otState?.basePerHour)
                                                                                }}
                                                                                required
                                                                                min={0.00} />
                                                                        </Col>
                                                                        <Col span={5}>
                                                                            <FormInputNumber
                                                                                textAlign={'right'}
                                                                                controls={false}
                                                                                disabled
                                                                                name={`${item?.id}_ot_amount`}
                                                                                required
                                                                                min={0.00} />
                                                                        </Col>
                                                                    </Row>
                                                                </List.Item>
                                                            )} />
                                                        <Row>
                                                            <Col span={9} style={{ textAlign: 'right', paddingRight: 15 }}><span style={{ color: "#667085" }}>รวมค่าล่วงเวลา</span></Col>
                                                            <Col span={5} style={{ textAlign: 'right' }}><span></span></Col>
                                                            <Col span={5} style={{ textAlign: 'right', paddingRight: 15 }} ><span >{get2DecimalPointsWithCommas(Object.keys(getFieldsValue(true)).filter(o => o.match(".*_totalCal$")).map(o => getFieldValue(o)).reduce((sum, o) => sum + Number(o), 0.00))}</span></Col>
                                                            <Col span={5} style={{ textAlign: 'right', paddingRight: 15 }}><span >{get2DecimalPointsWithCommas(Object.keys(getFieldsValue(true)).filter(o => o.match(".*_ot_amount$")).map(o => getFieldValue(o)).reduce((sum, o) => sum + Number(o), 0.00))}</span></Col>
                                                        </Row>
                                                    </Flex>
                                                </div>
                                            </Card>
                                        </Space>
                                    </Col>
                                </Row>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Modal>
        },
        [employmentIncome, form, getOvertimeInPeriod, i18n.language, onSaveEditRow, onSearchOt, openOt.id, openOt.open, otState?.basePerHour, otState?.overtimeShiftDetails, t],
    )


    useEffect(() => {
        if (currentCompany) {
            getEmploymentTypeIncomeDeductForSetup();
        }
    }, [currentCompany, getEmploymentTypeIncomeDeductForSetup])

    // useEffect(() => {
    //     if (currentCompany) {
    //         getTxnPaymentListByPaginationSize();
    //     }
    // }, [currentCompany, getTxnPaymentListByPaginationSize])
    const onPageChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log("tablePagination", tablePagination);
            onFinish()
            setPagination(prev => ({
                ...prev,
                page: tablePagination.current,
                current: tablePagination.current,
                pageSize: tablePagination.pageSize,
                size: tablePagination.pageSize,
                total: employeeGroupCalculation.length,
            }));
        },
        [employeeGroupCalculation.length, onFinish, setPagination]
    );
    const getTableForm = useCallback(() => {
        return (
            <GroupCalculationFormTable
                form={form}
                column={mergedColumns}
                EditableCell={EditableCell}
                dataSource={employeeGroupCalculation}
                isLoading={isLoading}
                onFinish={onFinish}
                pagination={pagination}
                setPagination={setPagination}
                onPageChange={onPageChange}
            />
        )
    }, [form, mergedColumns, EditableCell, employeeGroupCalculation, isLoading, onFinish, pagination, onPageChange])


    useEffect(() => {
        console.log("dataStorage ", newDataStorage);
    }, [newDataStorage])

    return {
        payrollPeriodId: id,
        // getTable,
        paginationSize,
        onPaginationSizeChange,
        form,
        EditableCell,
        dataSource: employeeGroupCalculation,
        column: column,
        calSuccess,
        getTableForm,
        onSubmitAll,
        getFilter: () => { },
        onRecalculation: onFinish,
        modelOt,
        isLoading
    }
}
export default useGroupCalculation